import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

const styles = theme => ({
  root: {
    overflowX: 'auto',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    padding: '10px',
    backgroundColor: "black"
  },
  item: {
    display: 'table-cell',
    textAlign: "center",
    minWidth: 350,
    [theme.breakpoints.up('xs')]: {
      display: 'table-cell',
      minWidth: '200',
    },
    backgroundColor: "black",
  },
});

function PhotoHorizontalSlider(props) {
  const { children, classes } = props;
  let i = 0;
  React.Children.map(children, () => { i++ });
  if (i === 0) {
    return "";
  }
  return (
    <Grid className={classes.root} container wrap="nowrap" spacing={8}>
      {React.Children.map(children, (child, i) => (
        <Grid className={classes.item} key={i} item xs={12}>
          {child}
        </Grid>
      ))}
    </Grid>
  );
}

PhotoHorizontalSlider.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element),
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(PhotoHorizontalSlider);
